import { createContext, useContext } from 'react';

/**
 * A server validation message reaches the field it names (`docs/ui-kit.md` X4): a dialog (`FormDialog`) provides the
 * lookup from its last problem; a `TextField`, `Select` or `MultiSelect` with a `name` shows the message for that name
 * (unless the caller passes its own `error`) and is marked invalid.
 */
export const FieldErrorContext = createContext<((name: string) => string | undefined) | null>(null);

/** The server's message for the field `name` in the surrounding dialog, if any. */
export function useServerFieldError(name?: string): string | undefined {
  const lookup = useContext(FieldErrorContext);
  return name && lookup ? lookup(name) : undefined;
}
